import React from 'react';
import { Product } from '../../utils/grocyApi.ts';
import ProductPicker from '../../components/ProductPicker.tsx';

interface ParentProductSelectorProps {
  parentProductId: number | null;
  onSelect: (product: Product) => void;
  onClear: () => void;
  searchTerm: string;
  onSearchTermChange: (term: string) => void;
  products: Product[] | undefined;
}

const ParentProductSelector: React.FC<ParentProductSelectorProps> = ({
  parentProductId,
  onSelect,
  onClear,
  searchTerm,
  onSearchTermChange,
  products,
}) => {
  return (
    <div className="purchase-controls__parent-product-picker">
      {!parentProductId ? (
        <ProductPicker
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          onSelect={onSelect}
          sortMode="parent-selection"
          showList={Boolean(searchTerm)}
        />
      ) : (
        <>
          <div className="purchase-controls__selected-parent">
            {products?.find(p => p.id === parentProductId)?.name || 'Selected product'}
          </div>
          <button
            type="button"
            onClick={onClear}
            className="purchase-controls__clear-parent"
            title="Clear parent product"
          >
            ×
          </button>
        </>
      )}
    </div>
  );
};

export default ParentProductSelector;
